import { ApiResponse } from "admin/src/ui/types/common/api-response";
import { ApiQueryConfig } from "api";

const GetSubmissionWorkflows: ApiQueryConfig<
  ApiResponse<any[]>,
  { societyId: string },
  {
    profileId: number;
    type:
      | "Membership"
      | "Submission"
      | "Simple"
      | "Registration"
      | "Conference"
      | "Group";
  }
> = {
  queryKey: { baseQueryKey: ["GetSubmissionWorkflows"] },
  apiPath: "/api/v1/society/{societyId}/workflow/submissions",
};

const GetSubmissionWorkflow: ApiQueryConfig<
  ApiResponse<any>,
  { societyId: string; submissionWorkflowId: string },
  { profileId: number }
> = {
  queryKey: {
    baseQueryKey: ["GetSubmissionWorkflow"],
    dynamicQueryKey: ["submissionWorkflowId"],
  },
  apiPath:
    "/api/v1/society/{societyId}/workflow/submissions/{submissionWorkflowId}",
};

export { GetSubmissionWorkflow, GetSubmissionWorkflows };
